// Integrations page — all connected-integration state in one place.
//
// Rehomes the surface that used to live only under /brand: the
// OAuth-connected integrations picker (Instagram, Meta Ads, Google
// Ads, TikTok Shop stub) + the Meta ads cascade configuration.
// Home page is now the agent chat; navigation to this page comes
// from the secondary sidebar.
//
// The card component (IntegrationsCard) is reused verbatim from the
// Brand page so post-OAuth bounces that still target /brand keep
// working — this page is an additional entry point, not a rewrite.
// A follow-up will migrate the OAuth callback to redirect here
// directly, retire the /brand mount, and drop the duplication.

import { useRef } from 'react';
import { VStack } from '@chakra-ui/react';
import { PageHeader } from '../../shell/PageHeader';
import { IntegrationsCard, type IntegrationsCardHandle } from '../Brand/IntegrationsCard';
import { DataSourcesCard } from '../Brand/DataSourcesCard';
import { MetaCascadesCard } from '../Brand/MetaCascadesCard';
import { BrandLoadState } from '../Brand/BrandLoadState';

export function IntegrationsPage() {
  // Kept in case a future OAuth-bounce lands directly on /integrations
  // — mirrors the ref plumbing on the Brand page so we can pop the
  // post-connect picker without a second click. Nothing consumes it
  // today; not load-bearing yet.
  const integrationsRef = useRef<IntegrationsCardHandle>(null);

  return (
    <VStack align="stretch" spacing={6}>
      <PageHeader
        eyebrow="Integrations"
        title="Connected integrations"
        description="Every OAuth connection, sync setting, and Meta cascade config for the active brand."
      />

      <BrandLoadState>
        {(brand) => (
          <>
            <IntegrationsCard ref={integrationsRef} brand={brand} />
            {brand._id && <DataSourcesCard brandId={brand._id} />}
            {brand._id && <MetaCascadesCard brandId={brand._id} />}
          </>
        )}
      </BrandLoadState>
    </VStack>
  );
}

export default IntegrationsPage;
